<template>
  <div class="grid gap-3 sm:gap-4 md:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
    <!-- Prospects Section -->
    <template v-for="prospect in prospects">
      <ProspectCard
        v-if="prospect.progress_label === 'Prospect fase'"
        :key="`prospect-${prospect.id}`"
        :prospect="prospect"
        :badge="getProspectType(prospect.progress_label)"
        badge-class="bg-green-100 dark:bg-green-900/50 text-green-600 dark:text-green-400"
        :status-badge="
          getWorkflowStatusLabel(prospect.workflow_status, { isUrgent: prospect.is_urgent })
        "
        :status-badge-class="
          getWorkflowStatusBadgeClass(prospect.workflow_status, { isUrgent: prospect.is_urgent })
        "
        :border-color="
          getWorkflowBorderColor(prospect.workflow_status, { isUrgent: prospect.is_urgent })
        "
        @click="$emit('open-detail', prospect)"
      >
        <template #info>
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">
            Verantwoordelijke: {{ prospect.responsible_employee_name || 'Onbekend' }}
          </p>
        </template>
      </ProspectCard>
    </template>

    <!-- Separator between Prospects and Leads/Verkennings -->
    <div
      v-if="
        prospects.some(p => p.progress_label === 'Prospect fase') &&
        (prospects.some(p => p.progress_label === 'Lead fase') ||
          prospects.some(p => p.progress_label === 'Verkenningsfase'))
      "
      class="col-span-full mt-4 mb-0 border-t-2 border-gray-200 dark:border-gray-700 pt-4"
    >
      <h2 class="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">
        Leads en Verkenningen
      </h2>
    </div>

    <!-- Leads and Verkenningen Section -->
    <template v-for="prospect in prospects">
      <ProspectCard
        v-if="
          prospect.progress_label === 'Lead fase' || prospect.progress_label === 'Verkenningsfase'
        "
        :key="`lead-${prospect.id}`"
        :prospect="prospect"
        :badge="getProspectType(prospect.progress_label)"
        badge-class="bg-green-100 dark:bg-green-900/50 text-green-600 dark:text-green-400"
        :status-badge="
          getWorkflowStatusLabel(prospect.workflow_status, { isUrgent: prospect.is_urgent })
        "
        :status-badge-class="
          getWorkflowStatusBadgeClass(prospect.workflow_status, { isUrgent: prospect.is_urgent })
        "
        :border-color="
          getWorkflowBorderColor(prospect.workflow_status, { isUrgent: prospect.is_urgent })
        "
        @click="$emit('open-detail', prospect)"
      >
        <template #info>
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">
            Verantwoordelijke: {{ prospect.responsible_employee_name || 'Onbekend' }}
          </p>
        </template>
      </ProspectCard>
    </template>
  </div>
</template>

<script setup>
import ProspectCard from '@/components/common/cards/ProspectCard.vue'
import {
  getWorkflowStatusLabel,
  getWorkflowStatusBadgeClass,
  getWorkflowBorderColor
} from '@/utils/statusBadge'

defineProps({
  prospects: {
    type: Array,
    required: true
  }
})

defineEmits(['open-detail'])

const getProspectType = progressLabel => {
  const types = {
    'Prospect fase': 'PROSPECT',
    'Lead fase': 'LEAD',
    Verkenningsfase: 'VERKENNING'
  }
  return types[progressLabel] || 'UNKNOWN'
}
</script>
